import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  CommonStyle,
  CommonHeaderStyle,
  displayNullFormatter,
} from "../Utility/utilis";
import { useSelector } from "react-redux";
import moment from "moment";
import NoData from "../Utility/NoData";
import {
  Dialog,
  Typography,
} from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import ReactPaginate from "react-paginate";

const History = (props) => {
  const { historyData,totalPagesHistory } = useSelector((state) => state.noticeReducer);
  const [failureModalOpen, setFailureModalOpen] = useState(false);
  const [selectedFailureData, setSelectedFailureData] = useState(null);

  const handleFailureClick = (row) => {
    setSelectedFailureData(row?.FAIL_REASON || "No details available");
    setFailureModalOpen(true);
  };

  const handleCloseModal = () => {
    setFailureModalOpen(false);
    setSelectedFailureData(null);
  };

  const StatusColor = (row) => {
    const status = row?.STATUS?.toUpperCase();
    let color = "orange"; // Default for in-progress states

    if (status === "COMPLETED") {
      color = "green";
    } else if (status === "FAILED") {
      color = "red";
    } else if (
      status === "IN-PROGRESS" ||
      status === "INPROGRESS" ||
      status === "IN_PROGRESS"
    ) {
      color = "orange";
    }

    const isFailed = status === "FAILED";

    return (
      <div
        style={{
          width: "100%",
          textAlign: "center",
          color: color,
          fontWeight: "600",
          cursor: isFailed ? "pointer" : "default",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
        }}
        onClick={isFailed ? () => handleFailureClick(row) : undefined}
        title={isFailed ? "Click to view failure details" : ""}
      >
        {row.STATUS ? row.STATUS : "--"}
        {isFailed && (
          <ErrorOutlineIcon
            style={{
              fontSize: "16px",
              color: "red",
              marginLeft: "4px",
            }}
          />
        )}
      </div>
    );
  };

  const columns = [
    {
      dataField: "gstin",
      text: "GSTIN",
      style: () => ({ ...CommonStyle(), width: "25%" }),
      headerStyle: CommonHeaderStyle(),
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN"),
    },
    {
      dataField: "FROM_DATE",
      text: "From Date",
      style: () => ({ ...CommonStyle(), width: "25%" }),
      headerStyle: CommonHeaderStyle(),
      formatter: (cell, row) => {
        return row.FROM_DATE ? row.FROM_DATE : "--";
      },
    },
    {
      dataField: "CREATED_DATE",
      text: "Created Date",
      style: () => ({ ...CommonStyle(), width: "25%" }),
      headerStyle: CommonHeaderStyle(),
      formatter: (cell, row) => {
        return row.CREATED_DATE
          ? moment(row.CREATED_DATE).format("DD/MM/YYYY HH:mm:ss")
          : "--";
      },
    },
    {
      dataField: "STATUS",
      text: "Status",
      style: () => ({ ...CommonStyle(), width: "25%" }),
      headerStyle: CommonHeaderStyle(),
      formatter: (cell, row) => StatusColor(row),
    },
  ];

  useEffect(()=>{
    return ()=>{
      props.setPageNoHistory(1);
    }
  },[])
  return (
    <>
      {historyData?.length > 0 ? (
        <div
          style={{
            marginTop: "2em",
            width: "100%",
            // height: "25em",
            // overflowY: "auto",
          }}
        >
          <div className="light-border-notice-table">
            <BootstrapTable
              keyField="ID"
              data={historyData}
              columns={columns}
            />
          </div>
          <br />
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            forcePage={props.pageNoHistory - 1}
            pageCount={totalPagesHistory}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClickHistory}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            
          />
        </div>
        
      ) : (
        <NoData />
      )}

      {/* Failure Details Modal */}
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="xs"
        open={failureModalOpen}
      >
        <MuiDialogTitle
          disableTypography
          style={{ color: "#4f2d7f", backgroundColor: "white" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <Typography variant="h6">{"Failure Details"}</Typography>
            <CloseIcon
              onClick={handleCloseModal}
              style={{ cursor: "pointer" }}
            />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <div
            style={{
              display: "flex",
              textWrap: "wrap",
              wordBreak: "break-word",
            }}
          >
            {selectedFailureData}
          </div>
        </MuiDialogContent>
      </Dialog>
    </>
  );
};

export default History;
